import { FileDesc } from '@wellesley/openapi'

const extremeHeight = 100

const isExtremeCase = (file: FileDesc | null) => {
  if (!file) return false

  const height = file.meta.height || 0

  return height < extremeHeight
}

export default isExtremeCase
